import api from './services/api';
import { MobileContext } from "./contexts/MobileContext";
import { MenuContext } from "./contexts/MenuContext";
import { UserContext } from "./contexts/UserContext";
import { GlobalStyles } from "./GlobalStyles.styles";
import { Routes } from "./Routes";
import useUser from "./utils/useUser";
import useWindowDimensions from "./utils/useWindowDimensions";
// import { Footer } from "./components/Footer";
import { setDefaultLocale, registerLocale } from "react-datepicker";
import ptBR from 'date-fns/locale/pt-BR';
import { useState, useEffect } from "react";
registerLocale("pt-BR", ptBR);

const config = {
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': false
    }
}
const loadMenu = async () => {
    const menu = await api.get(`Settings/menu`, config);
    return menu?.data?.data
}

const loadEmpresas = async () => {
    const userEmpresas = await api.get(`usuario/empresas`, config);
    localStorage.setItem('empresasUsuario', JSON.stringify(userEmpresas?.data?.data))
}


function App() {
    setDefaultLocale('pt-BR')

    const { width } = useWindowDimensions();
    const isMobile = width < 699;
    const { user, setUser, authed } = useUser();
    const [menu, setMenu] = useState([])

    useEffect(() => {
        if (user?.name) {
            loadMenu().then(data => {
                setMenu(data)
            });
            loadEmpresas();
        }
    }, [user?.name])

    return (
        <>
            <MobileContext.Provider value={isMobile}>
                <UserContext.Provider value={{ user, setUser, authed }}>
                    <MenuContext.Provider value={menu}>
                        <GlobalStyles />
                        <Routes setUser={setUser} />
                    </MenuContext.Provider>
                </UserContext.Provider>
            </MobileContext.Provider>

        </>
    );
}

export default App;
